/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermeniSiConditiiRouteImport } from './routes/termeni-si-conditii'
import { Route as PoliticaDeConfidentialitateRouteImport } from './routes/politica-de-confidentialitate'
import { Route as PoliticaCookiesRouteImport } from './routes/politica-cookies'
import { Route as NicolleGheorghiuRouteImport } from './routes/nicolle-gheorghiu'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AncaVladRouteImport } from './routes/anca-vlad'
import { Route as IndexRouteImport } from './routes/index'

const TermeniSiConditiiRoute = TermeniSiConditiiRouteImport.update({
  id: '/termeni-si-conditii',
  path: '/termeni-si-conditii',
  getParentRoute: () => rootRouteImport,
} as any)
const PoliticaDeConfidentialitateRoute =
  PoliticaDeConfidentialitateRouteImport.update({
    id: '/politica-de-confidentialitate',
    path: '/politica-de-confidentialitate',
    getParentRoute: () => rootRouteImport,
  } as any)
const PoliticaCookiesRoute = PoliticaCookiesRouteImport.update({
  id: '/politica-cookies',
  path: '/politica-cookies',
  getParentRoute: () => rootRouteImport,
} as any)
const NicolleGheorghiuRoute = NicolleGheorghiuRouteImport.update({
  id: '/nicolle-gheorghiu',
  path: '/nicolle-gheorghiu',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AncaVladRoute = AncaVladRouteImport.update({
  id: '/anca-vlad',
  path: '/anca-vlad',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/anca-vlad': typeof AncaVladRoute
  '/contact': typeof ContactRoute
  '/nicolle-gheorghiu': typeof NicolleGheorghiuRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-de-confidentialitate': typeof PoliticaDeConfidentialitateRoute
  '/termeni-si-conditii': typeof TermeniSiConditiiRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/anca-vlad': typeof AncaVladRoute
  '/contact': typeof ContactRoute
  '/nicolle-gheorghiu': typeof NicolleGheorghiuRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-de-confidentialitate': typeof PoliticaDeConfidentialitateRoute
  '/termeni-si-conditii': typeof TermeniSiConditiiRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/anca-vlad': typeof AncaVladRoute
  '/contact': typeof ContactRoute
  '/nicolle-gheorghiu': typeof NicolleGheorghiuRoute
  '/politica-cookies': typeof PoliticaCookiesRoute
  '/politica-de-confidentialitate': typeof PoliticaDeConfidentialitateRoute
  '/termeni-si-conditii': typeof TermeniSiConditiiRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/anca-vlad'
    | '/contact'
    | '/nicolle-gheorghiu'
    | '/politica-cookies'
    | '/politica-de-confidentialitate'
    | '/termeni-si-conditii'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/anca-vlad'
    | '/contact'
    | '/nicolle-gheorghiu'
    | '/politica-cookies'
    | '/politica-de-confidentialitate'
    | '/termeni-si-conditii'
  id:
    | '__root__'
    | '/'
    | '/anca-vlad'
    | '/contact'
    | '/nicolle-gheorghiu'
    | '/politica-cookies'
    | '/politica-de-confidentialitate'
    | '/termeni-si-conditii'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AncaVladRoute: typeof AncaVladRoute
  ContactRoute: typeof ContactRoute
  NicolleGheorghiuRoute: typeof NicolleGheorghiuRoute
  PoliticaCookiesRoute: typeof PoliticaCookiesRoute
  PoliticaDeConfidentialitateRoute: typeof PoliticaDeConfidentialitateRoute
  TermeniSiConditiiRoute: typeof TermeniSiConditiiRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/termeni-si-conditii': {
      id: '/termeni-si-conditii'
      path: '/termeni-si-conditii'
      fullPath: '/termeni-si-conditii'
      preLoaderRoute: typeof TermeniSiConditiiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-de-confidentialitate': {
      id: '/politica-de-confidentialitate'
      path: '/politica-de-confidentialitate'
      fullPath: '/politica-de-confidentialitate'
      preLoaderRoute: typeof PoliticaDeConfidentialitateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/politica-cookies': {
      id: '/politica-cookies'
      path: '/politica-cookies'
      fullPath: '/politica-cookies'
      preLoaderRoute: typeof PoliticaCookiesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/nicolle-gheorghiu': {
      id: '/nicolle-gheorghiu'
      path: '/nicolle-gheorghiu'
      fullPath: '/nicolle-gheorghiu'
      preLoaderRoute: typeof NicolleGheorghiuRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/anca-vlad': {
      id: '/anca-vlad'
      path: '/anca-vlad'
      fullPath: '/anca-vlad'
      preLoaderRoute: typeof AncaVladRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AncaVladRoute: AncaVladRoute,
  ContactRoute: ContactRoute,
  NicolleGheorghiuRoute: NicolleGheorghiuRoute,
  PoliticaCookiesRoute: PoliticaCookiesRoute,
  PoliticaDeConfidentialitateRoute: PoliticaDeConfidentialitateRoute,
  TermeniSiConditiiRoute: TermeniSiConditiiRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
